"use client";

import { useEffect, useRef, useCallback } from "react";
import { HubConnection, HubConnectionState } from "@microsoft/signalr";
import { getSignalRConnection } from "@/lib/signalr";

/**
 * React hook that subscribes to a SignalR event.
 * Starts the connection if not already connected.
 */
export function useSignalR(
  eventName: string,
  callback: (...args: unknown[]) => void
) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  });

  const stableCallback = useCallback((...args: unknown[]) => {
    callbackRef.current(...args);
  }, []);

  useEffect(() => {
    const conn: HubConnection = getSignalRConnection();

    conn.on(eventName, stableCallback);

    if (conn.state === HubConnectionState.Disconnected) {
      conn.start().catch(console.error);
    }

    return () => {
      conn.off(eventName, stableCallback);
    };
  }, [eventName, stableCallback]);
}
